import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'sb-threeway-toggle-collection',
  templateUrl: './sb-threeway-toggle-collection.component.html',
  styleUrls: ['./sb-threeway-toggle-collection.component.scss'],
  standalone: false,
})
export class SbThreewayToggleCollectionComponent implements OnInit {
  @Output()
  modelChange = new EventEmitter<any>();

  @Input() titles: any;
  @Input() icons: any;
  @Input() disabled = false;

  _toggles: any;
  toggleModel: any = {};

  get toggles(): any {
    return this._toggles;
  }

  @Input()
  set toggles(prm: any) {
    if (prm) {
      this._toggles = prm;
      for (const key of Object.keys(this._toggles)) {
        this.toggleModel[key] = this._toggles[key];
      }
    }
  }

  keys(t) {
    return Object.keys(t);
  }

  onChange(togg, num) {
    this.toggleModel[togg] = num;
    this.modelChange.emit(this.toggleModel);
  }

  constructor() {}

  ngOnInit() {}
}
